import React from 'react';

const NotFound = () => {
    return (
        <div className='h-96'>
            <h1 className="text-red-700 text-center text-4xl font-medium pt-36">Your searching result are not found</h1>
            <h1 className='text-6xl text-center text-red-900 font-bold'>404!</h1>
        </div>
    );
};

export default NotFound;